import { Calendar, momentLocalizer } from "react-big-calendar";
import { Card } from "antd";
import { useMemo, useState, useRef } from "react";
import moment from "moment";
import "./Medicaid.scss";
import classNames from "classnames";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import BreadcrumbList from "../../../Shared/Components/Breadcrumb/Breadcrumb";
import CustomToolBar from "./CustomToolBar";
import MedicaidAgenda from "./MedicaidAgenda";

const localizer = momentLocalizer(moment);

const Medicaid = () => {
  const [date, setDate] = useState(new Date());
  const [defaultView, setDefaultView] = useState("month");
  const [view, setView] = useState(defaultView);
  const [currentDate, setCurrentDate] = useState(moment().startOf('day'));
  const currentDateRef  = useRef();
  currentDateRef.current = currentDate || new Date();

  const windowSize$ = useSharedState();

  const events = [
    {
      id: 1746,
      title: "Arcutis Meeting: Dr. Ashish Bhatia @ AAD",
      start: new Date("2026-02-08T02:00:00"),
      end: new Date("2026-02-08T02:30:00"),
       backgroundColor: "#C6E0B4",
      color: "#000000",
    },
    {
      id: 1746,
      title: "Arcutis Meeting: Dr. Ashish Bhatia @ AAD",
      start: new Date("2026-02-08T02:00:00"),
      end: new Date("2026-02-08T02:30:00"),
      backgroundColor: "#C6E0B4",
      color: "#000000",
    },
    {
      id: 1746,
      title: "Arcutis Meeting: Dr. Ashish Bhatia @ AAD",
      start: new Date("2026-02-08T02:00:00"),
      end: new Date("2026-02-08T02:30:00"),
       backgroundColor: "#C6E0B4",
      color: "#000000",
    },
    {
      id: 1746,
      title: "Arcutis Meeting: Dr. Ashish Bhatia @ AAD",
      start: new Date("2026-02-08T02:00:00"),
      end: new Date("2026-02-08T02:30:00"),
      backgroundColor: "#C6E0B4",
      color: "#000000",
    },
    
    {
      id: 1747,
      title: "Arcutis Meeting Dr. Christopher Obeime, MD AAD 2026 12:00 PM",
      start: new Date("2026-02-09T21:30:00"),
      end: new Date("2026-02-09T22:30:00"),
       backgroundColor: "#C6E0B4",
      color: "#000000",
    },
    {
      id: 1748,
      title: "AAD 2026 Mark Lebwohl + Arcutis @ 3:30pm EST [In-person]",
      start: new Date("2026-02-10T01:00:00"),
      end: new Date("2026-02-10T01:30:00"),
      backgroundColor: "#C6E0B4",
      color: "#000000",
    },
    {
      id: 1749,
      title: "Arcutis Meeting Dr. Scott Drew AAD 2026 3:00 pm",
      start: new Date("2026-02-09T01:30:00"),
      end: new Date("2026-02-09T01:55:00"),
       backgroundColor: "#C6E0B4",
      color: "#000000",
    },
  ];

  const hanldeViewChange = (newView) => {
    setView(newView)
  }

  const components = useMemo(
    () => ({
      toolbar:(props)=> <CustomToolBar updateView={hanldeViewChange} view={view} />,
    }),
    []
  );

  const columns = [
    {
      label: "Medicaid",
      link: "",
    },
  ];

  const eventPropsHandler = (event, start, end, isSelected) => {
    return {
      style: {
        backgroundColor: "transparent",
        borderRadius: "6px",
        color: event.color,
        border: "none",
        padding: "2px 6px",
        boxShadow: "none"
      },
    };
  };

  return (
    <div className="details-root" data-test="details-container">
      <div className="container">
        <Card bodyStyle={{ padding: "10px" }}>
          <BreadcrumbList active={columns} />
        </Card>

        <Card>
          <div
            className={classNames("calendar-height calender-big", {
              "margin-classs":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "margin-class":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
            {view && view === 'month' && (
              <Calendar
                localizer={localizer}
                defaultView={defaultView}
                events={events}
                startAccessor="start"
                endAccessor="end"
                date={date}
                view={view}
                onNavigate={setDate}
                onView={setView}
                components={components}
                eventPropGetter={eventPropsHandler}
              />
            )}
            {
              view && view === 'agenda' && (
                <MedicaidAgenda events={events} updateView={hanldeViewChange} currentDate={currentDateRef} view={view}/>
              )
            }
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Medicaid;


